import React from "react";
import { Container, Row, Col } from "shards-react";
import InvoicingSchedules from "../components/invoicing/InvoicingSchedules";

const InvoicingSchedulesView = () => {
  return (
    <Container fluid className="main-content-container px-4">
      <Row>
        <Col className="p-2">
          <InvoicingSchedules />
        </Col>
      </Row>
    </Container>
  );
};

export default InvoicingSchedulesView;
